<template>
  <!-- 申请开票 -->
 <div >
  <div class="detailsTitle">
      <h4>申请开票</h4>
      <div @click="back"><i class="fa fa-reply"></i></div>
  </div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true" ref="" class="demo-form-inline" label-width="110px" size="mini">
        <div class="searchBox inpBox">
            <div class="gjhBox">
              <el-form-item label="业务编号:" prop="businessNo">
                <el-input  placeholder=""   type="textarea" v-model="searchFrom.businessNo" class="gjh"></el-input>
              </el-form-item>
            </div>
            <div class="item">
               <el-form-item label="发布人:" prop="createUserName">
                <el-input  placeholder="" v-model="searchFrom.createUserName"></el-input>
              </el-form-item>
                <el-form-item label="业务类型:" prop="invoiceType">
                <el-select  v-model="searchFrom.invoiceType"   placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="运输业务" value="1"></el-option>
                  <el-option label="快递业务" value="2"></el-option>
                  <el-option label="找车业务" value="3"></el-option>
                </el-select>
              </el-form-item>
               <el-form-item label="开票企业:" prop="platformZxAccNm">
                <el-input  placeholder="" v-model="searchFrom.platformZxAccNm"></el-input>
              </el-form-item>
               <el-form-item label="发布部门:" prop="orgName">
                <el-input  placeholder="" v-model="searchFrom.orgName"></el-input>
              </el-form-item>
              <el-form-item label="付款时间:" prop="settlementTimes">
                <el-date-picker
                  v-model="searchFrom.settlementTimes"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </div>
        </div>
       <div class="searchBtnBox">
           <el-form-item >
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item >
            <el-button type="primary" @click="kaipiaoFn">确认打包</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"  @click="exportFn" :disabled="isDisable">导出</el-button>
          </el-form-item>
          <span style="color:red;margin-left:10px">已选开票金额：{{allMone}}元</span>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' height="100%" style="width: 100%" center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" fixed prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="业务编号"  width="200">
            <template slot-scope="scope">
              <span v-if="scope.row.invoiceType==1" style="color: #0e6eec;cursor: pointer;" @click="seeClickNO(scope.row)">{{scope.row.businessNo}}</span>
              <span v-else>{{scope.row.businessNo}}</span>
            </template>
        </el-table-column>
        <el-table-column property="invoiceType" label="业务类型">
          <template scope="scope">{{[ "运输业务","快递业务","找车业务"][scope.row.invoiceType-1]}}</template>
        </el-table-column>
       <el-table-column property="platformZxAccNm"  width="260"  :formatter="emptyFn"   label="开票企业"></el-table-column>
       <el-table-column property="weight"  width="120"  :formatter="emptyFn"   label="结算量"></el-table-column>
        <el-table-column property="publishPricingMethod" label="计价方式" >
          <template scope="scope" >
            <div>
              <span v-if="scope.row.invoiceType==1">{{[ "单价", "包干",][scope.row.pricingMethod-1]}}</span>
              <span v-if="scope.row.invoiceType!=1" >-</span>
            </div>
            </template>
        </el-table-column>
        <el-table-column property="unitPrice" width="100"   label="单价">
          <template scope="scope">
            <div>
            <span v-if="scope.row.invoiceType==1 &&scope.row.pricingMethod==1">{{scope.row.unitPrice}}元/{{scope.row.unitMeasurement}}</span>
            <span v-if="scope.row.invoiceType==1 &&scope.row.pricingMethod==2">-</span>
            <span v-if="scope.row.invoiceType!=1" >-</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="wayMoney"  width="140"  :formatter="emptyFn"   label="运费金额(元)"></el-table-column>
        <el-table-column property="serviceMoney"  width="140"  :formatter="emptyFn"   label="服务费金额(元)"></el-table-column>
        <el-table-column property="totalAmount"  width="140"  :formatter="emptyFn"   label="开票总金额(元)"></el-table-column>
        <el-table-column property="createUserName"  width="120"  :formatter="emptyFn"   label="发布人"></el-table-column>
        <el-table-column property="orgName"  width="200"  :formatter="emptyFn"   label="发布部门"></el-table-column>
        <el-table-column width="170" property="settlementTime" :formatter="dateTimeFormat" label="付款时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,300,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 打包开票 -->
    <el-dialog  title="打包开票"  :visible.sync="dialogDB" width="600px" class="detail"  :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="DBfrom" ref="DBfrom" :rules="rules" class="demo-form-inline jiaoyan" label-width="100px" size="mini">
        <div class="inpBox">
            <el-form-item label="开票单位:" prop="issuingOffice" class="ziti" >
              <template >
                <el-radio-group v-model="DBfrom.issuingOffice" >
                  <el-radio label="件">件</el-radio>
                  <el-radio label="方">方</el-radio>
                  <el-radio label="吨">吨</el-radio>
                </el-radio-group>
              </template>
           </el-form-item>
           <el-form-item label="备注:" class="remark" prop="remark"  >
              <el-input type="textarea"  :rows="4"  placeholder="" style="width:300px"  maxlength="500" v-model="DBfrom.remark"></el-input>
            </el-form-item>
        </div>
        <div style="background: rgba(225,50,70,0.1);padding: 4px 20px; margin-top:20px">
            <p>提示</p>
            <p>1、平台按照运费、服务费分开开具开票；</p>
            <p>2、申请开票前请核对您当前的开票信息是否正确，确认无误后再提交！</p>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="DBsave('PJFrom')">确认申请</el-button>
        <el-button @click="dialogDB = false">关闭</el-button>
      </span>
   </el-dialog>
    <!-- 订单详情 -->
    <orderDetail :rowData="row"  v-if="orderDetilFlag"  @destroy="destroy"></orderDetail>
 </div>

</template>

<script>
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, toFixed } from '@/utils/util'
import orderDetail from '@/views/consignment/payCustomer/settlement/orderDetail.vue'
import {
  listApply, // 列表
  confirmInvoice
} from '@/api/consignment'
export default {
  components: {
    orderDetail
  },
  data () {
    return {
      isDisable: false,
      allMone: 0,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      toFixed: toFixed,
      h: '500px',
      // 查询调价
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      loading: false,
      total: 0,
      // 打包开票
      dialogDB: false,
      DBfrom: {},
      // 订单详情
      orderDetilFlag: false,
      row: {},
      ids: [],
      rules: {
        issuingOffice: { required: true, message: '请选择单位', trigger: 'blur' }
      },
      btnFlg: [],
      btnIdArr: ['00JP009B001', '00JP009B002', '00JP009B003', '00JP009B004']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/lookGoods/appoint')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 134) + 'px'
  },
  methods: {
    // 导出
    exportFn () {
      let form = this.searchFrom
      exportExcel(
        this.global.payServer + '/owner/invoice/exportApplyInvoiceList',
        form,
        '申请开票列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 打包开票
    kaipiaoFn () {
      const selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        this.ids = []
        this.DBfrom = {}
        let unitMeasurement = selectData[0].unitMeasurement
        let platformZxAccNm = selectData[0].platformZxAccNm
        let invoiceType = selectData[0].invoiceType
        let allMone = 0
        let flag = selectData.every(item => {
          this.ids.push(item.id)
          allMone += item.totalAmount
          return item.platformZxAccNm == platformZxAccNm && item.invoiceType == invoiceType && item.unitMeasurement == unitMeasurement
        })
        allMone = this.toFixed(allMone, 2)
        if (flag) {
          if (allMone < 10000000) {
            this.DBfrom.ids = this.ids
            if (unitMeasurement == '吨' || !unitMeasurement) {
              this.DBfrom.issuingOffice = '吨'
              this.$confirm('是否打包发票?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.jiekouFn()
              }).catch(() => {

              })
            } else {
              this.dialogDB = true
            }
          } else {
            this.$alert('开票金额不能大于等于1000万，现在开票金额为' + allMone + '元', '系统提示')
          }
        } else {
          this.$alert('请选择开票企业、业务类型和开票单位一样的结算单', '系统提示')
        }
      }
    },
    DBsave () {
      this.$refs.DBfrom.validate((valid) => {
        if (valid) {
          this.jiekouFn()
        }
      })
    },
    jiekouFn () {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      confirmInvoice(this.DBfrom).then(res => {
        loading.close()
        this.$message({
          message: '成功',
          type: 'success'
        })
        this.$router.push({ path: '/payCustomer/invoice' })
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 订单详情
    seeClickNO (row) {
      this.row = row
      this.orderDetilFlag = true
    },
    destroy () {
      this.orderDetilFlag = false
    },
    // 查选
    searchFn () {
      if (this.searchFrom.businessNo) { this.searchFrom.businessNos = this.searchFrom.businessNo.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      this.allMone = 0
      // console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })

      const selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        this.ids = []
        let allMone = 0
        let flag = selectData.every(item => {
          // console.log(item);
          this.ids.push(item.id)
          // console.log(this.ids);
          allMone += item.totalAmount
          return allMone
        })
        this.allMone = this.toFixed(allMone, 2)
        if (flag) {
          if (allMone > 10000000) {
          // console.log(this.allMone);
          // this.$message.error("开票金额不能大于10万元")
            this.$alert('开票金额不能大于等于1000万', '系统提示')
          }
        }
      }
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      listApply(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    billDetails (row) {
      this.$router.push({ name: 'billDetails', query: { billId: row.id } })
    },

    // 重置
    resetForm (formName) {
      // debugger
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        updateTimes: null
      }
    },
    back () {
      this.$router.go(-1)// 返回上一层
    },
    closeDialog () {
      this.addForm = {}
      this.CHFrom = {}
    }
  }
}
</script>

<style scoped lang='less'>
.inpBox .el-date-editor{
      width: 350px!important;
}
</style>
